<template>
  <div class="auth-page-wrap">
    <div class="auth-card">
      <h1>修改密码</h1>
      <div class="form-field">
        <input v-model="form.email" placeholder="邮箱" />
      </div>
      <div class="form-field pwd-field">
        <input :type="showOldPassword ? 'text' : 'password'" v-model="form.oldPassword" placeholder="当前密码"/>
        <span class="eye-btn" @click="showOldPassword = !showOldPassword">{{ showOldPassword ? '🙈' : '👁' }}</span>
      </div>
      <div class="form-field pwd-field">
        <input :type="showPassword ? 'text' : 'password'" v-model="form.password" placeholder="新密码"/>
        <span class="eye-btn" @click="showPassword = !showPassword">{{ showPassword ? '🙈' : '👁' }}</span>
      </div>
      <div class="form-field pwd-field">
        <input :type="showPassword2 ? 'text' : 'password'" v-model="form.password2" placeholder="确认新密码"/>
        <span class="eye-btn" @click="showPassword2 = !showPassword2">{{ showPassword2 ? '🙈' : '👁' }}</span>
      </div>
      <button class="btn-submit" @click="reset">确认修改</button>
    </div>
  </div>
</template>

<script>
import { updatePwd } from '@/utils/http'
import { bus } from '@/utils/bus'

export default {
  data() {
    return {
      form: { email: '', oldPassword: '', password: '', password2: '' },
      showOldPassword: false,
      showPassword: false,
      showPassword2: false
    }
  },
  methods: {
    async reset() {
      if (this.form.password !== this.form.password2) {
        this.$alert('两次密码不一致', '提示', { confirmButtonText: '确定', center: true })
        return
      }
      const res = await updatePwd(this.form)
      if (res.status && res.status === 200) {
        localStorage.removeItem('uuid')
        localStorage.removeItem('user')
        bus.$emit('logout')
        this.$router.push('/login')
      } else {
        this.$alert(res.message, '提示', { confirmButtonText: '确定', center: true })
      }
    }
  }
}
</script>
